import React from "react"
import OurTechnologiesImg from "../../../images/atom.svg"
//import Switch from "../../../utils/Switch"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-8 px-6 pb-8">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2 md:pr-4">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Our</span>
            Technologies
          </h1>
          <p className="pb-12">
            We are passionate about technological development. We use various
            tools to ensure client quality and delight users, generating
            solutions that adapt to their needs.
          </p>
          {/* <Switch /> */}
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img
            src={OurTechnologiesImg}
            alt="Our Technologies"
            className="mx-auto"
            width="400"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
